<template>
  <div class="card mt-4">
    <div class="table-responsive">
      <div class="table-controls m-3 d-flex">
        <div class="controls-wrap d-flex align-items-center">
          <!-- Integration Field -->
          <Search
            class="mr-3"
            placeholderText="Search (title and description)"
            @search="doSearch"
          />
          <div class="mr-3 ml-auto">
            <v-select
              style="min-width: 350px"
              v-model="listOfSelectedEmployers"
              @input="handleSearchFilters"
              :options="getEmployersDropdown"
              placeholder="All Employers"
              inputId="employer-select"
              label="name"
              multiple
              :reduce="employer => employer"
              :clearable="true"
            >
              <template #option="{ name }"> {{ name }}</template></v-select
            >
          </div>

          <div
            v-show="!isPreviouslySubmited"
            class="published"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Include previously reviewed jobs"
            @click="
              isPreviouslySubmited = !isPreviouslySubmited;
              handleSearchFilters($event);
            "
          >
            <span class="fa-stack">
              <i class="fas fa-briefcase" :class="isPreviouslySubmited ? 'is-clicked' : ''"></i>
            </span>
          </div>

          <div
            class="published"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Exclude previously reviewed jobs"
            @click="
              isPreviouslySubmited = !isPreviouslySubmited;
              handleSearchFilters($event);
            "
            v-show="isPreviouslySubmited"
          >
            <span class="fa-stack">
              <i class="fas fa-briefcase" :class="isPreviouslySubmited ? 'is-clicked' : ''"></i>
            </span>
          </div>
        </div>

        <!-- <button
          type="button"
          class="ml-auto btn btn-success text-nowrap desktop-only"
          @click="showModal = true"
        >
          Add Job
          <portal to="review-add-job-modal">
            <CustomMainModal @close="onCloseAddJobModal" v-show="showModal">
              <template v-slot:header>
                <h5>Add Job</h5>
              </template>
              <AddJobBtnModal />
            </CustomMainModal>
          </portal>
        </button>
        <portal-target name="review-add-job-modal"></portal-target> -->
      </div>

      <table class="table table-striped custom-table desktop-only-table">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col">Title</th>
            <th nowrap scope="col">Employer</th>
            <th nowrap scope="col">Location</th>
            <th nowrap scope="col">Status</th>
            <th nowrap scope="col" style="width: 1%">&nbsp;</th>
            <th nowrap scope="col" style="width: 1%">&nbsp;</th>
            <th nowrap scope="col" style="width: 1%">Submitted</th>
            <th nowrap scope="col" style="width: 5%">&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          <tr class="list-complete-item" v-for="job in getReviewJobsList" :key="job.id">
            <td id="title" nowrap>
              <router-link :to="{ name: 'job_uuid', params: { job_uuid: job.id } }">{{
                job.title
              }}</router-link>
            </td>
            <td id="employer" nowrap>
              <router-link
                :to="{ name: 'employer_id', params: { employer_id: job.js_employer_id } }"
                >{{ job.employer_name }}</router-link
              >
            </td>
            <td id="location">{{ getLocation(job.country, job.city) }}</td>

            <td id="status" align="center">
              <div class="d-flex align-items-center">
                <div
                  :class="[
                    getStatusColorClass(job.status),
                    'flex-shrink-0',
                    'stage-size',
                    'rounded-circle',
                    'mr-2',
                  ]"
                ></div>
                <span
                  :class="[
                    getStatusTitle(job.status).status !== '' ? 'text-nowrap' : 'mr-0',
                    'stage-text',
                  ]"
                  >{{ getStatusTitle(job.status).status }}</span
                >
              </div>
            </td>

            <td id="service level">
              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">{{ serviceLevel(job.service_level).title }}</div>
                <router-link slot="reference" to>
                  <svgHelper :name="serviceLevel(job.service_level).title" class="mr-2"></svgHelper>
                </router-link>
              </popper>
            </td>

            <td id="icons" align="center" nowrap>
              <div class="d-flex justify-content-center align-items-center">
                <popper
                  class="mr-2"
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    {{ job.relocation ? 'Relocation assistance' : 'No relocation assistance' }}
                  </div>
                  <svgHelper
                    slot="reference"
                    :name="job.relocation ? 'relocate' : 'relocateFalse'"
                  ></svgHelper>
                </popper>

                <popper
                  class="mr-2"
                  trigger="hover"
                  :options="{
                    placement: 'top',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">{{ getEmploymentType(job.employment_type).name }}</div>
                  <svgHelper
                    slot="reference"
                    :name="getEmploymentType(job.employment_type).name"
                  ></svgHelper>
                </popper>
              </div>
            </td>
            <td id="date" nowrap>
              <div class="">
                <popper
                  class="mr-2"
                  trigger="hover"
                  :options="{
                    placement: 'right',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    {{
                      job.created_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: true,
                        })
                    }}
                  </div>
                  <span slot="reference">
                    {{
                      job.created_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </span>
                </popper>
              </div>
            </td>

            <td id="actions" align="center">
              <div class="icon-wrapper d-flex justify-content-around">
                <!-- Аpproved -->

                <popper
                  v-if="getJobStatusMixin(job.status).title === 'Published'"
                  class="approve-btn"
                  trigger="hover"
                  :options="{
                    placement: 'left',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    Approved
                    {{
                      job.approval_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </div>
                  <span slot="reference">
                    <svgHelper name="thumbsUpFill" />
                  </span>
                </popper>

                <popper
                  v-if="getJobStatusMixin(job.status).title === 'Closed'"
                  trigger="hover"
                  :options="{
                    placement: 'left',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    Approved
                    {{
                      job.approval_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </div>
                  <span slot="reference">
                    <svgHelper name="thumbsUpFill" />
                  </span>
                </popper>

                <svgHelper
                  style="fill: #f02800"
                  v-if="getJobStatusMixin(job.status).title === 'Closed'"
                  name="thumbsDown"
                />

                <!-- STATUS APPROVED -->
                <popper
                  v-if="getJobStatusMixin(job.status).title === 'Approved'"
                  trigger="hover"
                  :options="{
                    placement: 'left',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    Approved
                    {{
                      job.approval_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </div>
                  <span slot="reference">
                    <svgHelper name="thumbsUpFill" />
                  </span>
                </popper>

                <svgHelper
                  style="fill: #f02800"
                  v-if="getJobStatusMixin(job.status).title === 'Approved'"
                  name="thumbsDown"
                />
                <!-- END STATUS APPROVED -->

                <router-link to v-if="getJobStatusMixin(job.status).title === 'Published'">
                  <svgHelper style="fill: #f02800" name="thumbsDown" />
                </router-link>

                <router-link
                  v-if="getJobStatusMixin(job.status).title === 'Submitted'"
                  to
                  data-toggle="modal"
                  data-target=".bd-like-btn"
                  @click.native="setJobForAction(job)"
                >
                  <svgHelper class="approve-btn mr-3" style="fill: #28a745" name="thumbsUp" />
                </router-link>

                <router-link
                  v-if="getJobStatusMixin(job.status).title === 'Submitted'"
                  to
                  data-toggle="modal"
                  data-target=".bd-dislike-btn"
                  @click.native="setJobForAction(job)"
                >
                  <svgHelper style="fill: #f02800" class="decline-btn" name="thumbsDown" />

                  <!-- Thumbs down -->
                </router-link>

                <svgHelper
                  v-if="getJobStatusMixin(job.status).title === 'Rejected'"
                  style="fill: #28a745"
                  name="thumbsUp"
                />

                <popper
                  v-if="getJobStatusMixin(job.status).title === 'Rejected'"
                  trigger="hover"
                  :options="{
                    placement: 'left',
                    modifiers: { offset: { offset: '0,10px' } },
                  }"
                >
                  <div class="popper">
                    Declined
                    {{
                      job.rejected_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </div>
                  <span slot="reference">
                    <svgHelper style="fill: #f02800" name="thumbsDownFill" />
                  </span>
                </popper>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <ErrorList
        v-show="getReviewJobsList.length === 0"
        class="no-data-message"
        name="noReviewJobs"
      />
    </div>

    <section class="mobile-qualification mobile-only">
      <ul class="list-unstyled">
        <li>
          <div class="d-flex">
            <a class="job-ad-title" href="#">Java Developer</a>
            <span class="ml-auto date">2020-09-30 15:57</span>
          </div>
          <div class="d-flex">
            <a class="company-name" href="#">Comstream</a>
            <span class="ml-auto date">Sofia, Bulgaria</span>
          </div>
          <div class="d-flex align-items-center">
            <div class="mr-auto">
              <popper
                class="mr-2"
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">Relocation</div>
                <svgHelper slot="reference" name="relocate"></svgHelper>
              </popper>
              <popper
                class="mr-3"
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">{{ 'Self-employment' }}</div>
                <svgHelper slot="reference" name="selfEmployment"></svgHelper>
              </popper>
              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }"
              >
                <div class="popper">Sourcing</div>
                <router-link slot="reference" to>
                  <svgHelper name="sourcing" class="mr-2"></svgHelper>
                </router-link>
              </popper>
            </div>
            <div class="ml-auto action-buttons">
              <router-link to>
                <svgHelper
                  class="mr-2 green"
                  data-toggle="modal"
                  data-target=".bd-like-btn"
                  name="thumbsUp"
                ></svgHelper>
              </router-link>

              <router-link to>
                <svgHelper
                  data-toggle="modal"
                  data-target=".bd-dislike-btn"
                  class="mr-2 red"
                  name="thumbsDown"
                ></svgHelper>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </section>

    <Spinner :isLoading="isLoading" />

    <div class="d-flex ml-auto mt-auto bottom-controls">
      <div class="d-none d-sm-block" id="pagination">
        <!-- Pagination -->

        <Pagination
          :currentPage="getCurrentPage"
          :totalPages="getTotalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @selectPageByNumber="setPageByNumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
          @keyup="keymonitor"
        />
      </div>
    </div>

    <!-- Modals -->

    <div
      class="modal fade bd-like-btn"
      tabindex="-1"
      role="dialog"
      aria-labelledby="mainModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Approve job</h5>
            <button
              ref="approveClose"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Please confirm that you want to approve the job ad for the position as
              <b> {{ selectedJobForApproval.title }} </b> for
              <b> {{ selectedJobForApproval.employer_name }}. </b>
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button @click="approveJob" type="button" class="btn btn-primary btn-custom">
              Confirm
            </button>
            <button
              @click="selectedJobForApproval = {}"
              type="button"
              class="btn btn-secondary btn-custom"
              data-dismiss="modal"
              ref="closeApproveModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade bd-dislike-btn"
      tabindex="-1"
      role="dialog"
      aria-labelledby="mainModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Reject job</h5>

            <button
              ref="closeDeclineTest"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Please confirm that you want to reject the job ad for the position as
              <b> {{ selectedJobForApproval.title }} </b> for
              <b> {{ selectedJobForApproval.employer_name }}. </b>
            </p>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button @click="rejectJob" ref="rejectJobCancel" type="button" class="btn btn-primary">
              Reject
            </button>
            <button
              @click="selectedJobForApproval = {}"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              ref="closeRejectModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modals -->
  </div>
</template>

<script>
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';
import { mapActions, mapGetters } from 'vuex';
import Pagination from '@/components/Navigations/Pagination';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import AddJobBtnModal from '@/components/Admin/Jobs/AddJobBtnModal';

import Search from '../../common/Search/Search';
import { employmentMixin } from '../../../mixins/employmentMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import { errorService } from '../../../services/errorService';
import { jobStatusMixin } from '../../../mixins/jobStatusMixin';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import titleMixin from '../../../mixins/titleMixin';
import ErrorList from '@/components/common/errorsList';

export default {
  components: {
    Pagination,
    CustomMainModal,
    AddJobBtnModal,
    Search,
    ErrorList,
  },
  mixins: [
    titleMixin,
    displayResultsBasedOnScreenHeightMixin,
    employmentMixin,
    serviceLevelMixin,
    jobStatusMixin,
    statusMixin,
    stagesMixin,
  ],
  title() {
    return 'Review jobs | Jobshark';
  },
  data: () => ({
    jobs: [],
    selectedJobForApproval: {},
    selectedJobForRejection: {},
    isPreviouslySubmited: false,
    isLoading: false,
    listOfSelectedEmployers: [],
    employersSelectOptions: [],
    showModal: false,
    searchText: '',
    pageCount: 10,
    currentPage: 1,
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveReviewJobs',
      'approveReviewJob',
      'rejectReviewJob',
    ]),
    onCloseAddJobModal() {
      this.showModal = false;
    },
    doSearch(searchedText) {
      this.searchText = searchedText;

      this.currentPage = 1;

      if (this.searchText.length >= 3) {
        this.isLoading = true;

        this.retrieveReviewJobs({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          previously_reviewed_jobs: this.isPreviouslySubmited,
          page: Number(this.currentPage),
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }

      if (searchedText === '') {
        this.isLoading = true;
        this.searchText = searchedText;

        this.retrieveReviewJobs({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          previously_reviewed_jobs: this.isPreviouslySubmited,
          page: Number(this.currentPage),
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    getLocation(country, city) {
      if (city.name && country.name) {
        return `${city.name}, ${country.name}`;
      }
      return null;
    },
    handleSearchFilters() {
      this.isLoading = true;

      this.currentPage = 1;

      this.retrieveReviewJobs({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),
        previously_reviewed_jobs: this.isPreviouslySubmited,
        page: Number(this.currentPage),
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setJobForAction(job) {
      this.selectedJobForApproval = job;
    },
    approveJob() {
      this.isLoading = true;

      this.approveReviewJob({ js_employer_jobad_id: this.selectedJobForApproval.id }).then(() => {
        this.retrieveReviewJobs({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          previously_reviewed_jobs: this.isPreviouslySubmited,
          page: Number(this.currentPage),
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;

            this.$refs.closeApproveModal.click();
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
    rejectJob() {
      this.isLoading = true;

      this.rejectReviewJob({ js_employers_jobad_id: this.selectedJobForApproval.id }).then(() => {
        this.retrieveReviewJobs({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          previously_reviewed_jobs: this.isPreviouslySubmited,
          page: Number(this.currentPage),
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
            this.$refs.closeRejectModal.click();
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        // this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        // this.previousPage();
      }
    },
    nextPage() {
      if (this.currentPage >= 1) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveReviewJobs({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          previously_reviewed_jobs: this.isPreviouslySubmited,
          page: Number(this.currentPage),
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.retrieveReviewJobs({
          search_word: this.searchText,
          employers: this.listOfSelectedEmployers.map(item => item.id),
          previously_reviewed_jobs: this.isPreviouslySubmited,
          page: Number(this.currentPage),
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.currentPage = 1;
      }
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.isLoading = true;
      this.currentPage = pageNumber;

      this.retrieveReviewJobs({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),
        previously_reviewed_jobs: this.isPreviouslySubmited,
        page: Number(this.currentPage),
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.retrieveReviewJobs({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),
        previously_reviewed_jobs: this.isPreviouslySubmited,
        page: Number(this.currentPage),
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.retrieveReviewJobs({
        search_word: this.searchText,
        employers: this.listOfSelectedEmployers.map(item => item.id),
        previously_reviewed_jobs: this.isPreviouslySubmited,
        page: Number(this.currentPage),
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters([
      'getEmployersDropdown',
      'getReviewJobsList',
      'getUserProfile',
      'getCurrentPage',
      'getTotalPages',
    ]),
  },
  mounted() {
    this.isLoading = true;
    this.displayResultsBasedOnScreen();

    this.retrieveEmployersDropdown();

    this.retrieveReviewJobs({
      search_word: this.searchText,
      employers: this.listOfSelectedEmployers.map(item => item.id),
      previously_reviewed_jobs: this.isPreviouslySubmited,
      page: Number(this.currentPage),
      count: this.pageCount,
    })
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });

    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.table-controls {
  // min-height: 50vh;
}

.modal-body {
  p {
    margin-bottom: 0;
  }
}

.fa-briefcase {
  font-size: 18px;
}

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  /*  a {
    fill: #28a745;

    &:hover {
      fill: #1e8035;
    }
  } */

  /* a:not(:first-child) {
    fill: #f02800;

    &:hover {
      fill: #b61e00;
    }
  } */
}

.mobile-only {
  display: none;
}

.desktop-only {
  display: block;
}

.desktop-only-table {
  display: table;
  table-layout: auto;
}

.controls-wrap {
  width: 100%;
  .integration-group {
    width: 39.3%;
  }
}

.card {
  height: 81.7vh;
}

@media only screen and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .card {
    min-height: 100vh;
    margin: 24px 0px 0 0px !important;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    min-height: 100vh;
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .card {
      min-height: 100vh !important;
      margin-top: 0 !important;
    }
  }
  .mobile-qualification {
    font-family: $font-family-sans-lato;
    display: block;
    .list-unstyled {
      li {
        a {
          text-decoration: none;
        }
        .job-ad-title {
          display: block;
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .company-name {
          color: $color-orange;
          font-size: 15px;
          margin-bottom: 5px;
        }
        .date {
          color: #5f5f5f;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 18px 15px 18px;
        .svg-icon {
          width: 22px;
          height: 22px;
          display: inline-block;
        }
        .action-buttons {
          margin-top: 8px;
          .svg-icon {
            width: 22px;
            height: 22px;
            display: inline-block;
          }
          .green {
            fill: #28a745;
          }
          .red {
            fill: #f02800;
            margin-left: 10px;
          }
        }
      }
    }
  }
  .controls-wrap {
    width: 100%;
    .integration-group {
      width: 100%;
    }
  }
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .desktop-only-table {
    display: none;
  }
}
</style>
